const boxesPalette = ['#739dc2', '#8cafcd', '#a6c1d8'];
export { boxesPalette };
